import { Component, Input, TemplateRef, input } from '@angular/core';

@Component({
  selector: 'customer-component-tooltip',
  templateUrl: './component-tooltip.component.html',
  styleUrls: ['./component-tooltip.component.scss'],
  standalone: false
})
export class ComponentTooltipComponent {
  readonly icon = input<string>(undefined);
  @Input() triggerComponent: TemplateRef<unknown>;
  readonly disable = input(false);
  readonly iconSize = input('15px');
  public isVisible: boolean;

  public displayOverlay(): void {
    if (!this.disable()) {
      this.isVisible = true;
    }
  }

  public hideOverlay(): void {
    this.isVisible = false;
  }
}
